import openWindow from '@/script/openWindow.mjs'
import {useMapContext} from '@/components/MindMap/index.mjs'

export default props => {
    const map = useMapContext()
    const {mapTypeCode, prjId, prjTypeCode, sVer} = map.data

    if (! (
        'BM' === prjTypeCode &&
        /^(SA|_PA)_MAP$/.test(mapTypeCode)
    )) {
        return null
    }

    const onClick = () => {
        openWindow(
            '/Ai',

            {
                dpIds: [map.root.data.pkid],
                prjId,
                scene: 'GENERATE_WS',
                sVer,
            }
        )
    }

    return {
        label: '知识结构建模',
        onClick,
        ...props,
    }
}
